import React from 'react';
import ImageIcon from '@material-ui/icons/Image';

const Image = (props) => <ImageIcon {...props} />;

export default Image;
